import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import MetaTags from "react-meta-tags";
import {
    Container,
    Row,
} from "reactstrap";
import CompoundForm from "../CompoundForm"
import CompoundService from "services/Admin/CompoundService"
import { SuccessCreated, SuccessOk } from "configs/statusCode";
import { adminPrefix } from "configs/routePrefix";
const EditCompound = (props) => {
    const id = props.match.params.id

    return (
        <>
            <div className='page-content'>
                <MetaTags>
                    <title>Compounds</title>
                </MetaTags>
                <Container fluid>
                    <Row className="mx-4">
                        <h4>{id ? "Update Compound " : "Add New Compound"}</h4>
                        <p>Follow the following steps and add the required info. to add compound</p>
                    </Row>
                    <CompoundForm id={id} fromParams={true} history={props.history} />

                </Container>
            </div>
        </>
    )
}

export default EditCompound